module.exports = __webpack_public_path__ + "img/banner.d76b38bd.png";